export default "__VITE_PUBLIC_ASSET__88aa3dfe__"